import React from 'react';
import { Icon } from '@chakra-ui/icons';
import { Color } from '../../theme/color';

export const XoctagonIcon = ({ ...props }: any) => {
	return (
		<Icon
			width="22"
			height="22"
			viewBox="0 0 22 22"
			fill="none"
			{...props}
		>
			<path
				d="M6.86 1.02832H15.14L21 6.88832V15.1683L15.14 21.0283H6.86L1 15.1683V6.88832L6.86 1.02832Z"
				stroke={Color.ACTION}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 8.02832L8 14.0283"
				stroke={Color.ACTION}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 8.02832L14 14.0283"
				stroke={Color.ACTION}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
